import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { PageHeader } from './PageHeader';
import { mockAgents } from '../data/mockData';
export function Layout() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const getPageTitle = () => {
    const path = location.pathname.replace('/', '');
    // Handle agent detail routes - extract agent ID and show agent name
    const agentMatch = path.match(/^app-ai\/(\d+)/);
    if (agentMatch) {
      const agentId = agentMatch[1];
      const agent = mockAgents.find(a => a.id === agentId);
      return agent ? agent.name : 'Service';
    }
    // Handle nested routes
    if (path.startsWith('app-ai')) {
      return 'Service';
    }
    const pathMap: Record<string, string> = {
      overview: 'Engine AI',
      policy: 'Policy management',
      comportamento: 'Comportamento',
      istruzioni: 'Istruzioni',
      conoscenza: 'Conoscenza',
      actions: 'Actions',
      models: 'Models',
      consumi: 'Consumi',
      strumenti: 'Strumenti',
      widgets: 'Widgets',
      utenti: 'Utenti',
      storico: 'Storico',
      'tutti-gli-agenti': 'Tutti i servizi',
      'gestione-costi': 'Gestione costi',
      impostazioni: 'Impostazioni',
      costi: 'Costi'
    };
    return pathMap[path] || 'Dashboard';
  };
  return <div className="flex min-h-screen bg-[#FAFAFA] dark:bg-black transition-colors duration-180" data-id="element-308">
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} data-id="element-309" />

      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarCollapsed ? 'lg:ml-[80px]' : 'lg:ml-[260px]'}`} data-id="element-310">
        <PageHeader onOpenMobileMenu={() => setIsMobileMenuOpen(true)} data-id="element-311" />

        <main className="flex-1 px-4 py-6 lg:px-6 lg:py-8 overflow-y-auto custom-scrollbar" data-id="element-312">
          <div className="max-w-[1600px] mx-auto w-full" data-id="element-313">
            {/* Page Title with Action Slot */}

            <Outlet data-id="element-314" />
          </div>
        </main>
      </div>
    </div>;
}